export const createMarkup = (text: string) => ({ __html: text });
